export default "__VITE_ASSET__CgcOOZHq__"